/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancellation_ScheduledInputs */



/**
* | output |
* | --- |
* | "Cancellation Scheduled" |
*
* @param {Cancellation_ScheduledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancellation_scheduled = /** @type {((inputs?: Cancellation_ScheduledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancellation_ScheduledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annulation prévue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stornierung geplant")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancellazione programmata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмена запланированного рейса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelación programada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已安排取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャンセル予定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रद्द करने की योजना बनाई गई है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelamento agendado")
	return /** @type {LocalizedString} */ ("Cancellation Scheduled")
});